import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { axiosBeelineRequest } from '@beef/utils';
import { EEndpoint, EResponseStatus } from "./constants";
export var fetchIsBeelineUser = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var accountNumber, userType, _ref$baseUrl, baseUrl, _yield$axiosBeelineRe, CtnStatus;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          accountNumber = _ref.accountNumber, userType = _ref.userType, _ref$baseUrl = _ref.baseUrl, baseUrl = _ref$baseUrl === void 0 ? '' : _ref$baseUrl;
          _context.prev = 1;
          _context.next = 4;
          return axiosBeelineRequest({
            url: "".concat(baseUrl).concat(EEndpoint.CheckCtn),
            params: {
              ctn: accountNumber,
              userType: userType
            }
          });
        case 4:
          _yield$axiosBeelineRe = _context.sent;
          CtnStatus = _yield$axiosBeelineRe.CtnStatus;
          return _context.abrupt("return", CtnStatus !== EResponseStatus.IsNonBeelineUser);
        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          console.error(_context.t0);
          return _context.abrupt("return", false);
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 9]]);
  }));
  return function fetchIsBeelineUser(_x) {
    return _ref2.apply(this, arguments);
  };
}();